import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { LOAD_RBAC_ITEMS, LOAD_USER_PERMISSIONS } from 'constants/ActionTypes';
import { fetchResource, getIntlMessage, showErrorMessage } from 'helpers/utilHelpers';
import { loadRbacItemsSuccess, loadUserPermissionsSuccess } from 'actions/entities/rbacActions';

function* fetchRbacItems() {
  try {
    const loadedItems = yield call(() => fetchResource('items', 'GET', {}, {}, {}, 'rbac'));
    yield put(loadRbacItemsSuccess(loadedItems));
  } catch (error) {
    yield showErrorMessage(getIntlMessage('rbac.load.error'));
  }
}

function* fetchUserPermissions() {
  try {
    const permissions = yield call(() => fetchResource('permissions', 'GET', {}, {}, {}, 'rbac'));
    yield put(loadUserPermissionsSuccess(permissions));
  } catch (error) {
    yield showErrorMessage(getIntlMessage('permissions.load.error'));
  }
}

function* loadRbacItems() {
  yield takeEvery(LOAD_RBAC_ITEMS, fetchRbacItems);
}

function* loadUserPermissions() {
  yield takeEvery(LOAD_USER_PERMISSIONS, fetchUserPermissions);
}

export default function* rootSaga() {
  yield all([fork(loadRbacItems), fork(loadUserPermissions)]);
}
